(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["japes-experience"] && !Shopify.designMode) return;
  try {
    function initialiseJapesNavigation(){
 const drawer=document.querySelector('[data-jr-drawer]');
 const opener=document.querySelector('[data-jr-menu-open]');
 if(!drawer||!opener||drawer.dataset.ready)return;
 drawer.dataset.ready='true';
 let previousFocus=null;
 let previousOverflow='';
 function close(){
  if(!drawer.classList.contains('is-open'))return;
  drawer.classList.remove('is-open');drawer.setAttribute('aria-hidden','true');drawer.inert=true;
  opener.setAttribute('aria-expanded','false');document.documentElement.style.overflow=previousOverflow;
  if(previousFocus)previousFocus.focus();
 }
 opener.addEventListener('click',()=>{
  previousFocus=document.activeElement;previousOverflow=document.documentElement.style.overflow;
  drawer.inert=false;drawer.classList.add('is-open');drawer.setAttribute('aria-hidden','false');opener.setAttribute('aria-expanded','true');
  document.documentElement.style.overflow='hidden';drawer.scrollTop=0;drawer.querySelector('[data-jr-menu-close]').focus();
 });
 drawer.querySelector('[data-jr-menu-close]').addEventListener('click',close);
 drawer.querySelectorAll('a').forEach(link=>link.addEventListener('click',close));
 document.addEventListener('keydown',event=>{
  if(!drawer.classList.contains('is-open'))return;
  if(event.key==='Escape'){event.preventDefault();close();}
  if(event.key==='Tab'){
   const items=Array.from(drawer.querySelectorAll('a[href],button:not([disabled])')).filter(el=>el.offsetParent!==null);
   const first=items[0],last=items[items.length-1];
   if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
   else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
  }
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialiseJapesNavigation);else initialiseJapesNavigation();
document.addEventListener('shopify:section:load',initialiseJapesNavigation);

function initialiseJapesMarquees(root=document){
 const marquees=root.matches&&root.matches('[data-jr-marquee]')?[root]:root.querySelectorAll('[data-jr-marquee]');
 marquees.forEach(marquee=>{
  if(marquee.dataset.jrMarqueeReady==='true')return;
  const button=marquee.querySelector('[data-jr-marquee-toggle]');
  const track=marquee.querySelector('.jr-marquee-track');
  if(!button||!track||!button.dataset.pauseLabel||!button.dataset.resumeLabel)return;
  marquee.dataset.jrMarqueePaused='false';
  button.setAttribute('aria-label',button.dataset.pauseLabel);
  button.addEventListener('click',()=>{
   const paused=marquee.dataset.jrMarqueePaused!=='true';
   marquee.dataset.jrMarqueePaused=String(paused);
   button.setAttribute('aria-label',paused?button.dataset.resumeLabel:button.dataset.pauseLabel);
  });
  marquee.dataset.jrMarqueeReady='true';
  button.hidden=false;
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initialiseJapesMarquees());else initialiseJapesMarquees();
document.addEventListener('shopify:section:load',event=>initialiseJapesMarquees(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["japes-large-bookings"] && !Shopify.designMode) return;
  try {
    function initialiseJapesGroupForm() {
    const bookingDate = document.getElementById('JapesGroupDate');
    if (bookingDate) {
      const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
      const readPart = (type) => parts.find((part) => part.type === type).value;
      bookingDate.min = `${readPart('year')}-${readPart('month')}-${readPart('day')}`;
    }
    const result = document.querySelector('[data-jr-group-result]');
    if (result) result.focus();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseJapesGroupForm);
  } else {
    initialiseJapesGroupForm();
  }
  document.addEventListener('shopify:section:load', initialiseJapesGroupForm);
  } catch(e) { console.error(e); }
})();

})();
